import React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@components/Button";
import { ExclamationCircleIcon } from "@components/icons";
import { Modal } from "@components/Modal/Modal";
import { useModal } from "@hooks/useModal";
import { type IUseModalProps } from "@store/modal/modal";
import { sanitizeHtml } from "@utils/html";

interface ConfirmEmailUncheckModal extends IUseModalProps {
  onConfirm: () => void;
}

export const ConfirmEmailUncheckModal: React.FC<ConfirmEmailUncheckModal> = (
  props,
) => {
  const { onConfirm, ...rest } = props;
  const { t } = useTranslation();
  const modal = useModal(rest);

  return (
    <Modal
      modal={modal}
      title={t("confirmEmailUncheckModal.title")}
      subtitle={
        <span
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(t("confirmEmailUncheckModal.subtitle")),
          }}
        />
      }
      actionButtons={
        <React.Fragment>
          <Button className="w-full" variant="secondary" onClick={modal.close}>
            {t("confirmEmailUncheckModal.buttons.cancel")}
          </Button>
          <Button
            className="w-full"
            onClick={() => {
              onConfirm();
              modal.close();
            }}
          >
            {t("confirmEmailUncheckModal.buttons.submit")}
          </Button>
        </React.Fragment>
      }
      badgeProps={{
        icon: ExclamationCircleIcon,
        color: "red",
      }}
    ></Modal>
  );
};
